import { render } from "./NewMessageComposer.vue?vue&type=template&id=33b6b521&scoped=true"
import script from "./NewMessageComposer.vue?vue&type=script&lang=js"
export * from "./NewMessageComposer.vue?vue&type=script&lang=js"

import "./NewMessageComposer.vue?vue&type=style&index=0&id=33b6b521&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b6b521"]])

export default __exports__